module.exports = __webpack_public_path__ + "ca.svg?0efb6bf1f18132e87ea2c57d9580c45c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ca.svg
// module id = 1284
// module chunks = 0